import React from 'react';
import { arrayOf, shape, number, string, func, bool } from 'prop-types';
import clsx from 'clsx';
import { useChatStore } from 'stores/chat';

import Avatar from 'components/Chat/Avatar/Avatar';
import GameController from 'themes/common/svg/game-controller.svg';
import styles from './RoomList.module.scss';

const bingoRoomsIsVisibleSelector = (state) => state.bingoRoomsIsVisible;

function RoomList({
  currentRoomId,
  rooms,
  isVisible,
  onClick,
  hasUserList,
  miniGameListId,
}) {
  const roomsAsc = [...rooms].reverse();
  const bingoRoomsIsVisible = useChatStore(bingoRoomsIsVisibleSelector);
  return (
    <div
      className={clsx(styles.wrapper, {
        [styles.isVisible]: isVisible,
      })}
    >
      {miniGameListId && (
        <button
          type="button"
          className={clsx(styles.tab, {
            [styles.isActive]: currentRoomId === 'minigames',
          })}
          onClick={() =>
            onClick({
              roomId: 'minigames',
              name: 'Mini Games',
              isMinigamesTab: true,
            })
          }
        >
          <GameController />
        </button>
      )}
      {roomsAsc.map(
        (room) =>
          room && (
            <button
              key={room.roomId}
              type="button"
              className={clsx(styles.tab, {
                [styles.isActive]:
                  currentRoomId === room.roomId && !hasUserList,
              })}
              onClick={() => onClick(room)}
            >
              <Avatar avatar={room.icon} />

              {(room.unreadCount > 0 && bingoRoomsIsVisible) ||
              (room.unreadCount > 0 && currentRoomId !== room.roomId) ? (
                <span className={styles.notice}>{room.unreadCount}</span>
              ) : null}
            </button>
          )
      )}
    </div>
  );
}

RoomList.propTypes = {
  miniGameListId: number,
  currentRoomId: string,
  rooms: arrayOf(
    shape({
      roomId: string,
      icon: number,
      updateAt: number,
      isPrivate: bool,
      unreadCount: number,
    })
  ),
  isVisible: bool,
  onClick: func,
  hasUserList: bool.isRequired,
};

RoomList.defaultProps = {
  miniGameListId: null,
  currentRoomId: null,
  rooms: [],
  isVisible: false,
  onClick: () => {},
};

export default RoomList;
